export default __webpack_public_path__ + "static/earth-alpha.min-d2cdaf0f40bd54442fb18fd2a04c9b45.jpg";